import clsx from "clsx";

// MUI
import { Stack } from "@mui/material";
import { GridToolbarContainer, GridToolbarProps, useGridApiContext } from "@mui/x-data-grid-premium";

// Common components
import HeaderToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/HeaderToolbar";
import ActionsToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/ActionsToolbar";

// Types
import { Nullable } from "@/Common/interfaces/types";
import { ReactNode } from "react";

export type CommonToolbarProps = Nullable<
	GridToolbarProps & {
		customTitle?: {
			hide: boolean;
			disabled: boolean;
			label: string;
			classes: string;
		};
		customAction?: {
			hide: boolean;
			disabled: boolean;
		};
		customComponent?: ReactNode;
	}
>;

export default function CommonToolbar(props: Readonly<CommonToolbarProps>) {
	const apiRef = useGridApiContext();
	let title = props?.customTitle ?? props?.title;
	if (typeof title === "string") {
		title = { hide: false, disabled: false, label: title, classes: "" };
	}

	const defaultActionsStyle = !props?.titleExpandible?.hide
		? {
				position: "absolute",
				right: "30px",
				top: "14px",
		  }
		: {};

	return (
		<GridToolbarContainer
			className={clsx({
				"!w-full !p-0 relative": true,
				"full-collapse-toolbar": !props?.titleExpandible?.hide,
				[props?.titleExpandible?.className ?? ""]: Boolean(props?.titleExpandible?.className),
			})}
		>
			{!props?.hide && (
				<Stack minHeight={40} direction="row" alignItems="flex-end" justifyContent="space-between" width="100%">
					<HeaderToolbar
						apiRef={apiRef}
						title={title}
						titleExpandible={props?.titleExpandible}
						switchProperties={props?.switch}
						customComponent={props?.customComponent}
					/>
					<ActionsToolbar
						apiRef={apiRef}
						confirm={props?.confirm}
						search={props?.search}
						filter={props?.filter}
						chargeBack={props?.chargeBack}
						arithmetic={props?.arithmetic}
						deleteProperties={props?.delete}
						expand={props?.expand}
						add={props?.add}
						customAction={props?.customAction}
						sxActions={props?.sxActions ?? defaultActionsStyle}
					/>
				</Stack>
			)}
		</GridToolbarContainer>
	);
}
